// import React, { useContext, useEffect, useState } from "react";
// import css from "../css/Refer.module.css";
// import { Link } from "react-router-dom";
// import axios from "axios";
// import Swal from "sweetalert2";

// import { BsWhatsapp } from "react-icons/bs";
// import { BsChevronDown } from 'react-icons/bs';
// import { BsPerson } from 'react-icons/bs';
// import { BsCash } from 'react-icons/bs';

// import { AiOutlineInstagram, AiFillFacebook } from "react-icons/ai";
// import CopyToClipboard from "react-copy-to-clipboard";
// import { FaTelegramPlane } from "react-icons/fa";
// import { FiCopy } from "react-icons/fi";
// import { LanguageContext } from "../Components/LanguageContext";
// import { useTheme } from "../../ThemeContext";

// const Refer = ({ user }) => {
//   const { language } = useContext(LanguageContext);
//   const theme = localStorage.getItem('theme')


//   const addsetting = localStorage.getItem("sitSetting");
//   const addCaseSetting = JSON.parse(addsetting);

//   const [cardData, setGame] = useState([]);

//   const copyCode = (e) => {
//     navigator.clipboard.writeText(user.referral_code);

//     Swal.fire({
//       position: "center",
//       icon: "success",
//       type: "success",
//       title: "Referral Code Copied",
//       showConfirmButton: false,
//       timer: 1200,
//     });
//   };

//   const copyLink = (e) => {
//     Swal.fire({
//       position: "center",
//       icon: "success",
//       type: "success",
//       title: "Referal Link Copied",
//       showConfirmButton: false,
//       timer: 1200,
//     });
//   };

//   if (user === undefined) {
//     return null;
//   }

//   const referralText = `Hi Friends, Play Malik Ludo.in Ludo and earn 10000 daily. Download Indian App Malik Ludo.in
//   बम्मफर  धमाका ऑफर  💸💸💸 💥💥💥💥💥💥
//    दोस्तो आ गया है भारत का पहला ऐसा गेमिंग प्लेटफॉर्म जहा आपको win पर रैफर कमीशन 4% दिया जाएगा अगर आपका दोस्त आपके रेफर से गेम खेलता तो आपको 4% commission दिया जायेगा

//     NK ADDA पर लूडो खेल कर या दोस्तों को शेयर कर के पैसा जीतो और तुरंत अपने Bank या UPI में ट्रांसफर कर सकते हो 
//     100% भरोसेमंद प्लेटफार्म । 24 hours support https://Malik Ludo.in/login/${user.referral_code}

//     Your ReferralCode is -${user.referral_code}.`


//   // language 


//   const translations = {
//     hi: {
//       referral: 'आपकी रेफरल कमाई',
//       referPerson: 'आमंत्रित किये दोस्त | ',
//       referEarn: 'रेफरल कमाई  ',
//       referCode: 'रेफरल कोड ',
//     },
//     en: {
//       referral: 'Your Referral Earnings',
//       referPerson: 'Referred Players',
//       referEarn: 'Referral Earning',
//       referCode: 'Referral Code',
//     },
//   };

//   // change theme 

//   const styles = {
//     backgroundColor: theme === 'light' ? '#d3e3fd' : 'black',
//     color: theme === 'light' ? 'black' : 'black',
//   };
//   const styles1 = {
//     color: theme === 'light' ? 'black' : 'white',
//   };


//   return (
//     <>
//       {/* <Header user={user} /> */}
//       <div style={styles}>
//         <div
//           className="leftContainer mt-5 pt-5"
//           style={{ ...styles, height: "100%" }}
//         >
//           <section className="referUnique">

//             {/* NEW STYLE INTRO CARD */}
//             <div className="introRibbonCard">
//               <div className="ribbonBar"></div>

//               <div className="ribbonContent">
//                 <img src="/images/refer.png" className="refer_icon" />
//                 <div>
//                   <h3>Refer & Earn</h3>
//                   <p>You can earn more more real money doing refer to your friends</p>
//                 </div>
//               </div>
//             </div>

//             {/* REFERRAL CODE CARD */}
//             <div className="codeLayerCard">
//               <label>Your Referral Code</label>

//               <div className="codeRow">
//                 <strong>{user.referral_code}</strong>

//                 <button className="copySmall" onClick={(e) => copyCode(e)}>
//                   Copy
//                 </button>
//               </div>
//             </div>
//             <div className="whatsapp_share_btn">
//               <a
//                 href={`whatsapp://send?text=Play%20On%20Malik Ludo.in%20%0A%E0%A4%B2%E0%A5%82%E0%A4%A1%E0%A5%8B%20%E0%A4%96%E0%A5%87%E0%A4%B2%20%E0%A4%95%E0%A4%B0%20%E0%A4%AF%E0%A4%BE%20%E0%A4%A6%E0%A5%8B%E0%A4%B8%E0%A5%8D%E0%A4%A4%E0%A5%8B%E0%A4%82%20%E0%A4%95%E0%A5%8B%20%E0%A4%B6%E0%A5%87%E0%A4%AF%E0%A4%B0%20%E0%A4%95%E0%A4%B0%20%E0%A4%95%E0%A5%87%20%E0%A4%AA%E0%A5%88%E0%A4%B8%E0%A4%BE%20%E0%A4%9C%E0%A5%80%E0%A4%A4%E0%A5%8B%20%E0%A4%94%E0%A4%B0%20%E0%A4%A4%E0%A5%81%E0%A4%B0%E0%A4%82%E0%A4%A4%20%E0%A4%85%E0%A4%AA%E0%A4%A8%E0%A5%87%20Bank%20%E0%A4%AF%E0%A4%BE%20UPI%20%E0%A4%AE%E0%A5%87%E0%A4%82%20%E0%A4%9F%E0%A5%8D%E0%A4%B0%E0%A4%BE%E0%A4%82%E0%A4%B8%E0%A4%AB%E0%A4%B0%20%E0%A4%95%E0%A4%B0%20%E0%A4%B8%E0%A4%95%E0%A4%A4%E0%A5%87%20%E0%A4%B9%E0%A5%88%E0%A5%A4%0A%0AAuto%20Deposit%20%26%20Auto%20Withdrawal%0A%0AInstant%20Withdrawal%20Via%20UPI%2FBank%2FWallet%20%0A%0ACommission%205%25%20Only%0AReferral%20commission%203%25%0A%0A100%25%20%E0%A4%AD%E0%A4%B0%E0%A5%8B%E0%A4%B8%E0%A5%87%E0%A4%AE%E0%A4%82%E0%A4%A6%20%E0%A4%AA%E0%A5%8D%E0%A4%B0%E0%A5%87%E0%A4%9F%E0%A4%AB%E0%A4%BE%E0%A4%B0%E0%A5%8D%E0%A4%AE%20%0A%0A24x7%20Live%20Chat%20%26%20Call%20Support%0A%0Ahttps%3A%2F%2FMalik Ludo.inludo.com%2Flogin%2F${user.referral_code}`}



//               >
//                 <BsWhatsapp className="icons" />
//                 <span class="ml-2">Whatsapp</span>
//               </a>
//             </div>

//             {/* STATS */}
//             <div className="statsFlex">

//               <div className="statLayerCard">
//                 <div>
//                   <h4>{user.referral_user?.length}</h4>
//                   <p>People Referred</p>
//                 </div>
//                 <img src="/images/trophy.png" className="stat_icon" />
//               </div>

//               <div className="statLayerCard">
//                 <div>
//                   <h4>₹{user.referral_earning}</h4>
//                   <p>Total Earned</p>
//                 </div>
//                 <img src="/images/monney.png" className="stat_icon" />
//               </div>

//             </div>

//           </section>


//         </div>
//       </div>
//     </>
//   );
// };

// export default Refer;


import React, { useContext } from "react";
import Swal from "sweetalert2";
import { BsWhatsapp } from "react-icons/bs";
import { FiCopy } from "react-icons/fi";
import { LanguageContext } from "../Components/LanguageContext";
// import "./ReferUI.css"; 

const Refer = ({ user }) => {
  const { language } = useContext(LanguageContext);

  if (!user) return null;

  const copyCode = () => {
    navigator.clipboard.writeText(user.referral_code);
    Swal.fire({
      icon: "success",
      title: "Referral Code Copied",
      showConfirmButton: false,
      timer: 1000,
    });
  };

  // const shareText = `Play Malik Ludo and earn daily! Join using my code: ${user.referral_code} \nLink: https://Malik Ludo.in/login/${user.referral_code}`;
  const shareText = `🔥 Hello Dost 👋

Apni Site Malik Ludo par Game Khelo aur Daily Paisa Jeeto 💸

🎁 Referral Code se Join karo aur pao 3% Referral Commission ka fayda.

🕹️ Fast Deposit • Fast Withdraw • Real Cash Games

👉 Join Now:
https://malikludo.com/login/${user.referral_code}

🎯 Referral Code: ${user.referral_code}`;
  return (
    <div className="refer-page-wrapper leftContainer ">
      <div className="refer-main-container">

        <div className="refer-top-banner">
          <img src="./images/refer-top.png" className="img-fluid" />
        </div>

        <div className="reward-card">

          <div className="reward-shine"></div>

          <div className="floating-coin coin1">🪙</div>
          <div className="floating-coin coin2">💎</div>
          <div className="floating-coin coin3">🪙</div>

          <h4>Invite Friends & Earn</h4>

          <h2>Exclusive Rewards!</h2>



          <div className="reward-row">
            <span>1 Referral</span>
            <strong>3% Commission</strong>
          </div>

          <div className="reward-row">
            <span>Total Referrals</span>
            <strong>{user.referral_user?.length || 0}</strong>
          </div>

          <div className="reward-row">
            <span>Total Earnings</span>
            <strong>₹{user.referral_earning || 0}</strong>
          </div>

        </div>






        {/* Unique Referral Code Card */}
        <div className="referral-code-card">

          <div className="code-card-glow"></div>

          <div className="referral-header">
            🎁 YOUR UNIQUE REFERRAL CODE
          </div>

          <div className="code-row">

            <div className="dashed-code-box">
              <span>{user.referral_code}</span>
            </div>

            <button
              className="copy-btn-3d"
              onClick={copyCode}
            >
              <FiCopy />
              <span>Copy</span>
            </button>

          </div>

        </div>

        {/* WhatsApp Button */}
        {/* <a 
          href={`whatsapp://send?text=${encodeURIComponent(shareText)}`} 
          className="whatsapp-btn-full"
        >
          <BsWhatsapp className="wa-icon" /> WhatsApp
        </a> */}
        <a
          href={`whatsapp://send?text=${encodeURIComponent(shareText)}`}
          className="invite-green-btn"
        >
          <BsWhatsapp />
          Invite Friends
        </a>






      </div>
    </div>
  );
};

export default Refer;
